import cloneDeep from 'lodash/cloneDeep';

import type { LogicCondition } from '@webapp/common/entities/logic';
import type { QuestionCol } from '@webapp/common/entities/question-col';
import type { QuestionRow } from '@webapp/common/entities/question-row';
import { initialQuestion as _initialQuestion } from '@webapp/common/resources/entities/question';
import type { QuestionParams } from '@webapp/common/resources/question';
import type { QuestionType } from '@webapp/common/resources/survey';

// TODO merge with questions

export interface LogicPageQuestion {
    id: number;
    expand: boolean;
    name: string;
    type: QuestionType;
    pageId: number;
    conditions: Array<LogicCondition>;
    params: QuestionParams;
    order: number;
    serial: number;
    rows: Array<QuestionRow>;
    cols: Array<QuestionCol>;
    pinned?: boolean;
    maxDiffBlockCount?: number;
}

export const initialQuestion: Readonly<LogicPageQuestion> = {
    expand: false,
    id: 0,
    name: '',
    type: null,
    pageId: 0,
    serial: 0,
    conditions: [],
    params: cloneDeep(_initialQuestion.params),
    order: 0,
    rows: [],
    cols: [],
};
